import { Box, Button, type SelectChangeEvent } from '@mui/material'
import { useEffect, useState } from 'react'
import { sendGet, sendPost } from 'hooks/use-fetch'
import { SelectWithLabel, type SelectOption } from 'Components/SelectWithLabel'
import { TextFieldWithLabel } from 'Components/TextField'
import { toast } from 'react-toastify'
import { ReportHeader } from 'Pages/Reports/ReportHeader'

export function GSRPEnrollmentTrendOptions (): JSX.Element {
  const [isds, setISDs] = useState<Array<SelectOption<number>>>([])
  const [isdID, setISDID] = useState<number | undefined>(undefined)
  const [year, setYear] = useState<number>(new Date().getFullYear())

  useEffect(() => {
    const fetchData = async (): Promise<void> => {
      const { response } = await sendGet('/Reporting/ISDs', {})
      setISDs(response)
    }
    void fetchData()
  }, [])

  const openReport = async (): Promise<void> => {
    if (isdID === undefined) {
      toast.error('Please select an ISD.')
    } else {
      const { response, success } = await sendPost('/Reporting/GSRPEnrollmentTrendURL', { isdID, year })
      if (success) {
        window.open(response, '_blank')?.focus()
      }
    }
  }

  return <>
    <ReportHeader title="GSRP Enrollment Trend Report" />
    <Box className='mt-10' >
      <SelectWithLabel
        name="isdID"
        label="ISD"
        value={isdID}
        width="100%"
        options={isds}
        onChange={(e) => { setISDID(Number(e.target.value)) }}
      />
      <TextFieldWithLabel
        label='Year'
        name='year'
        type='number'
        onChange={(e: SelectChangeEvent<string>): void => {
          setYear(Number(e.target.value))
        }}
        value={year ?? ''}
      />
    </ Box>

    <Box className='mt-10'>
      <Button color='secondary' variant='contained' onClick={openReport}>Preview</Button>
    </Box>
  </>
}
